import React from 'react';
import './Stepper.scss';
import { IonIcon } from '@ionic/react';
import { checkmarkOutline } from 'ionicons/icons';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import {
  COVID_APPOINTMENT_ROUTE,
  SIDEP_ONLY_APPOINTMENT_ROUTE
} from '../navigators/AppStackNavigator';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken
  };
};

export type StepperProps = ReturnType<typeof mapStateToProps> & {
  step: number;
};

interface StepProps {
  stepIndex: number;
  currentStep: number;
  displayedStepIndex?: number;
  title: string;
}

export const Step: React.FC<StepProps> = ({
  stepIndex,
  currentStep = 0,
  title,
  displayedStepIndex
}) => {
  displayedStepIndex = displayedStepIndex || stepIndex;

  return (
    <div
      className={`md-step ${stepIndex < currentStep ? 'done' : null} ${
        stepIndex === currentStep ? 'active' : null
      }`}
    >
      <div className="md-step-content">
        <div className="md-step-circle">
          {stepIndex < currentStep ? (
            <IonIcon icon={checkmarkOutline} />
          ) : (
            <span>{+displayedStepIndex + 1}</span>
          )}
        </div>
        <div className="md-step-title">{title}</div>
      </div>
      <div className="md-step-bar-left"></div>
      <div className="md-step-bar-right"></div>
    </div>
  );
};

const Stepper: React.FC<StepperProps> = ({ step, isLoggedIn }) => {
  const match = useRouteMatch();
  const isCovid = match.url.includes(COVID_APPOINTMENT_ROUTE);
  const isSidepOnly = match.url.includes(SIDEP_ONLY_APPOINTMENT_ROUTE);

  return (
    <div className="stepper">
      <div className="md-stepper-horizontal orange">
        {!isSidepOnly ? (
          <>
            <Step currentStep={step} stepIndex={0} title="Où ?" />
            <Step currentStep={step} stepIndex={1} title="Pour qui ?" />
            <Step currentStep={step} stepIndex={2} title="Ordonnance" />
            <Step currentStep={step} stepIndex={3} title="Quand ?" />
          </>
        ) : null}
        {/* <Step currentStep={step} stepIndex={3} title="Informations" /> */}
        {isCovid || isSidepOnly ? (
          <Step
            currentStep={step}
            stepIndex={isSidepOnly ? 0 : 4}
            title="Sidep"
          />
        ) : null}
        {isLoggedIn ? null : (
          <Step
            currentStep={step}
            stepIndex={isSidepOnly ? 1 : isCovid ? 5 : 4}
            title="Inscription"
          />
        )}
      </div>
    </div>
  );
};

export default connect(mapStateToProps, null)(Stepper);
